<template>
    <div v-if="promotion">
        <div class="app-promotion" v-if="!isPWA && !isNativeApp">
            <div class="downContent">
                <div class="promotion-wrapper">
                    <van-row style="align-items: center;">
                        <van-col span="2" class="close-icon" @click="closePromotion">
                            <van-icon name="cross" color="#fff" size="1.2 rem" />
                        </van-col>
                        <van-col span="4">
                            <div>
                                <img src="@/assets/themetwo/headsculpture_img_0.png" width="40px" height="40px" />
                            </div>
                        </van-col>
                        <van-col span="11">
                            <div style="color: white">
                                <p class="promotion-content" style="color: #fff">
                                    <img src="@/assets/themetwo/logo2.png" alt="" style="width:6rem">
                                </p>
                            </div>
                        </van-col>
                        <van-col span="6" style="text-align: end;">
                            <div @click="installApp">
                                <van-button class="download-btn"
                                    :style="`pointer-events: visible;    background-image: linear-gradient(270deg, rgb(225, 81, 164), rgb(230, 111, 200));`"
                                    size="mini">
                                    {{ $t('pwaInstructions.btnText') }}
                                </van-button>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </div>
    <IosInstruction v-if="isIos && iosInstructionPopup" @closeInstructions="closeInstructions" />
</template>

<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { checkIosPWAInstallable, installPWA } from '@/view/home/supportScript';
import IosInstruction from '@/view/iosInstruction/iosInstruction.vue';
import { Capacitor } from '@capacitor/core';
import { ref, defineEmits, onBeforeMount, computed } from 'vue';

const promotion = ref(false);
const isPWA = ref(false);
const isNativeApp = ref(false);
const isIos = ref(false);
const iosInstructionPopup = ref(false);
const userStore = useUserStore()
const pwaDomainInfo = computed(() => userStore.PWAdomainInfo)

const emit = defineEmits(['intallPWA', 'isClosedPWA', 'showPWA']);

const closePromotion = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    promotion.value = false;
    sessionStorage.setItem('openPromotionPopup', 'true');
    emit('isClosedPWA', promotion.value)
};

const closeInstructions = () => {
    iosInstructionPopup.value = false;
};


const installApp = () => {
    const url = pwaDomainInfo.value.domainName
    installPWA({
        url,
        isIos: isIos.value,
        iosPopupRef: iosInstructionPopup,
        emitInstall: () => emit('intallPWA')
    })
}


onBeforeMount(() => {
    isNativeApp.value = Capacitor.isNativePlatform();
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');

    promotion.value = true;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
    if (isStandalone || isNativeApp.value) {
        emit('isClosedPWA', false)
    }
    isIos.value = checkIosPWAInstallable()
});
</script>
<style scoped>
.promotion-wrapper {
    padding: 5px;
    margin: 0 auto;
}


.download-btn {
    color: white;
    width: fit-content;
    border-radius: 10px;
    font-size: 10px;
    padding: 15px;
    border: none;
}

.promotion-download {
    line-height: 65px !important;
    width: 65px !important;
}

.blue {
    color: rgb(148 216 252);
}

.green {
    color: #4AA41A;
}

.promotion-content {
    font-size: 12px;
    font-weight: bold;
    margin: 0;
}

.close-icon {
    display: flex;
    justify-content: start;
    pointer-events: visible;
    cursor: pointer;
}

/* Animation for sliding down when appearing */
@keyframes slideDown {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Animation for sliding up when disappearing */
@keyframes slideUp {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-100%);
        opacity: 0;
    }
}

.app-promotion {
    /* position: fixed; */
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* animation: slideDown 0.3s ease-out forwards; */
}

.app-promotion[style*="display: none"],
.app-promotion.hidden {
    animation: slideUp 0.3s ease-in forwards;
}

.downContent {
    background-image: linear-gradient(rgb(92, 31, 77), rgb(62, 45, 76));;
    background-size: cover;
    padding-left: 1vw;
}
</style>